import { render, staticRenderFns } from "./ToggleItems.vue?vue&type=template&id=41cff484&"
import script from "./ToggleItems.vue?vue&type=script&lang=js&"
export * from "./ToggleItems.vue?vue&type=script&lang=js&"
import style0 from "./ToggleItems.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
